import { Components, Theme } from "@mui/material";

const PAGINATION_THEME: Components<Theme>["MuiPagination"] = {
  styleOverrides: {
    root: ({ theme }: { theme: Theme }) => ({
      "& .MuiPaginationItem-root": {
        borderRadius: "16px",
        minWidth: "32px",
        height: "32px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "14px",
        fontWeight: 500,
        margin: 0,
        "&.MuiPaginationItem-previousNext": {
          width: "40px",
        },
        "&.Mui-selected": {
          color: theme.palette.primary.main,
          backgroundColor: "transparent",
          textDecoration: "underline",
          "&:hover": {
            backgroundColor: theme.palette.primary[50],
          },
        },
        "&:not(.Mui-selected)": {
          color: theme.palette.grey[400],
          backgroundColor: "transparent",
          "&:hover": {
            backgroundColor: theme.palette.grey[100],
          },
        },
      },
    }),
  },
};

export default PAGINATION_THEME;
